import {
  Action,
  OpenShiftsResponse as Response,
  Shift,
  convertScheduleChangeToShift,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { produce } from 'immer'
import { OpenShiftsData } from 'open_shifts/queries/types'
import { performAction } from 'shared/queries/perform_action'
import keys from './shared/keys'

type Variables = Action

export function usePerformOpenShiftsAction() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: mutateShift,
    onSuccess: async shift => {
      const key = keys.all

      if (shift) {
        const data = client.getQueryData<OpenShiftsData>(key)

        if (!data) {
          return
        }

        await client.cancelQueries({ queryKey: key })
        client.setQueryData<OpenShiftsData>(
          key,
          produce(data, updatedData => {
            for (const page of updatedData.pages) {
              const index = page.shifts.findIndex(s => s.id === shift.id)

              if (index >= 0) {
                page.shifts[index] = shift
                break
              }
            }
          })
        )
      } else {
        return client.invalidateQueries({ queryKey: key })
      }
    },
  })

  async function mutateShift(action: Variables): Promise<Shift | void> {
    const response = await performAction<Response.ScheduleChange>(
      server,
      action
    )

    if (response) {
      return convertScheduleChangeToShift(response)
    }
  }
}
